<template>
    <q-tabs
        no-caps
        inline-label
        mobile-arrows
        class="text-secondary"
        active-color="primary"
        active-bg-color="light-blue"
        content-class="text-accent"
        align="justify"
    >
        <q-route-tab
            v-for="tab in reportTabs"
            :key="tab.name"
            :name="tab.name"
            :to="getRoute(tab.name)"
            :icon="tab.icon"
            :label="tab.label"
            :disable="isLoadingReport"
        />
    </q-tabs>
</template>

<script>
import { mapState } from 'pinia';
import { useSettingsStore } from '@stores/settings.js';
import { useReportsStore } from '@stores/reports.ts';

export default {
    name: 'ReportNavigationTabs',
    data() {
        return {
            reportTabsData: [
                {
                    name: 'kpi',
                    label: this.$t('Overall KPI'),
                    icon: 'fa fa-tachometer-alt'
                },
                {
                    name: 'trends',
                    label: this.$t('Trends'),
                    icon: 'fa fa-chart-area'
                },
                {
                    name: 'losses',
                    label: this.$t('Losses'),
                    icon: 'fa fa-exclamation-circle'
                },
                {
                    name: 'data_entry_performance',
                    label: this.$t('Data Entry'),
                    icon: 'fas fa-map'
                },
                {
                    name: 'maintenance',
                    label: this.$t('Maintenance'),
                    icon: 'fa fa-wrench'
                },
                {
                    name: 'changeover',
                    label: this.$t('Changeovers'),
                    icon: 'fas fa-sync-alt'
                },
                {
                    name: 'benchmark',
                    label: this.$t('Benchmark'),
                    icon: 'fa-solid fa-magnifying-glass-chart'
                }
            ],
            qualityTab: {
                name: 'quality',
                label: this.$t('Quality'),
                icon: 'fa fa-clipboard-list-check'
            }
        };
    },
    computed: {
        ...mapState(useSettingsStore, ['isTrackingQualityEvents']),
        ...mapState(useReportsStore, ['isLoadingReport']),
        /**
         * Get the facility id from the route query.
         * @return {Number|null}
         */
        facilityId() {
            return this.$route.query.facility || null;
        },
        /**
         * Returns the list of report tabs, conditionally including the quality tab
         * based on isTrackingQualityEvents setting.
         * @returns {Array} List of report tabs
         */
        reportTabs() {
            const tabs = [...this.reportTabsData];
            if (this.isTrackingQualityEvents) {
                tabs.splice(6, 0, this.qualityTab);
            }
            return tabs;
        }
    },
    methods: {
        /**
         * Get the route object for the given name.
         * @param {String} name
         * @return {Object}
         */
        getRoute(name) {
            const routeObject = {
                name: name
            };

            /**
             * Adding 'facility: null' as a query value
             * breaks the active tab feature on the q-tabs component.
             * So, we only add the facility id if it exists.
             */
            if (this.facilityId) {
                routeObject.query = {
                    facility: this.facilityId
                };
            }

            return routeObject;
        }
    }
};
</script>
<style lang="scss" scoped>
.q-tabs {
    width: 100%;
}
.q-tab {
    border-bottom: 1px solid #ccc !important;
}
</style>
